export enum INPUT_TYPE {
  TEXT = 'text',
  PASSWORD = 'password',
}

export enum SCROLL_BLOCK {
  START = 'start',
  NEAREST = 'nearest',
}

export enum BALANCE_SLIDE_STEP {
  BONUS,
  CASH,
  TOTAL,
}

export enum INDICES {
  FIRST_INDEX = 'firstIndex',
  SECOND_INDEX = 'secondIndex',
  THIRD_INDEX = 'thirdIndex',
}

export enum NUMERIC_STATUS {
  FALSE = 0,
  TRUE = 1,
}

export enum SNACKBAR_SEVERITY {
  DEFAULT = 'default',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
}

export enum APP_AREA {
  FEATURED = 'Featured',
  SINGLE_SPORT = 'Single Sport',
  MY_BETS = 'My Bets',
  EVENT_DETAILS = 'Event Details',
  EVENT_LIST = 'Event List',
}
